import { LinkedTransactions, TransactionType } from 'vopay';

// A small set of TransactionType values (reversals, bank account records) aren't valid
// TransactionCard rail types and can never be a funding transaction's real payment child.
type ExcludedType =
  | TransactionType.FEE
  | TransactionType.REVERSAL
  | TransactionType.REVERSAL_INTERAC
  | TransactionType.REVERSAL_MONEY_REQUEST
  | TransactionType.BANK_ACCOUNT
  | TransactionType.RTR_WITHDRAWAL;

// Typed as string[] (not ExcludedType[]) so callers whose TransactionType field uses a
// differently-typed string literal (e.g. the generic transactions-history endpoint's
// TransactionTypesOptions) can compare against it directly, without a cast.
//
// 'Reversal' covers that generic endpoint, which collapses every reversal into one literal
// instead of REVERSAL_INTERAC/REVERSAL_MONEY_REQUEST. BANK_ACCOUNT has no equivalent there, so it
// only matches via the real TransactionType enum — harmless, not a reason to remove it.
export const NON_PAYMENT_TYPES: string[] = [
  TransactionType.FEE,
  TransactionType.REVERSAL,
  TransactionType.REVERSAL_INTERAC,
  TransactionType.REVERSAL_MONEY_REQUEST,
  TransactionType.BANK_ACCOUNT,
  TransactionType.RTR_WITHDRAWAL,
];

export const isPaymentSubTransaction = (
  subTransaction: LinkedTransactions,
): subTransaction is LinkedTransactions & { TransactionType: Exclude<TransactionType, ExcludedType> } =>
  !NON_PAYMENT_TYPES.includes(subTransaction.TransactionType);
